import {RESET_LINK_SENT} from "../action-types";

const initialState = {
    message: '',
    code: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case RESET_LINK_SENT: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
